import React from 'react';
import { motion } from 'framer-motion';
export function SolutionBenefits() {
  const benefits = [{
    emoji: '✨',
    text: <>
          Cada patrón respeta la{' '}
          <span className="text-teal font-bold" data-id="element-365">anatomía real de la raza</span>:
          las orejas, el hocico, la expresión única. No son genéricos.
        </>
  }, {
    emoji: '🎨',
    text: <>
          Guía incluida para adaptar cada patrón al{' '}
          <span className="text-teal font-bold" data-id="element-366">
            color exacto de TU mascota
          </span>
          . Manchas, tonos, marcas... que sea idéntico.
        </>
  }, {
    emoji: '🥹',
    text: <>
          Cuando lo vean, van a decir:{' '}
          <span className="text-teal font-bold" data-id="element-367">"¡Es igualito!"</span>.
          Prepárate para las lágrimas de emoción.
        </>
  }, {
    emoji: '🎬',
    text: <>
          <span className="text-teal font-bold" data-id="element-368">
            No necesitas experiencia previa
          </span>
          . Incluimos 10 videoclases de puntos básicos del crochet para que
          empieces desde cero con confianza.
        </>
  }];
  return <section className="py-10 md:py-16 bg-white" data-id="element-369">
      <div className="max-w-3xl mx-auto px-4" data-id="element-370">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-371">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-372">
            Imagina poder tejer{' '}
            <span className="text-terracotta italic border-b-2 border-terracotta/60 pb-0.5" data-id="element-373">
              exactamente
            </span>{' '}
            a tu mascota
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-374">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.4
        }} className="etsy-card p-5 flex items-start gap-4" data-id="element-375">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-376">
                {benefit.emoji}
              </span>
              <p className="text-gray-600 leading-relaxed" data-id="element-377">{benefit.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}